import React, { useState } from "react";
import { api, IMAGES } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import Seo from "@/components/Seo";
import MathCaptcha from "@/components/MathCaptcha";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", company: "", phone: "", subject: "General enquiry", message: "" });
  const [submitting, setSubmitting] = useState(false);
  const [captchaOk, setCaptchaOk] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) return toast.error("Name, email and message are required");
    if (!captchaOk) return toast.error("Captcha is incorrect. Please try again.");
    setSubmitting(true);
    try {
      await api.post("/contact", form);
      toast.success("Message received. Our team will respond within 24h.");
      setForm({ name: "", email: "", company: "", phone: "", subject: "General enquiry", message: "" });
    } catch (e) {
      toast.error("Could not send message");
    } finally { setSubmitting(false); }
  };
  return (
    <div className="py-24" data-testid="contact-page">
      <Seo path="/contact" exactTitle="Contact Ravemora Global | Get in Touch" description="Contact Ravemora Global for enquiries about learning, recruitment, payroll and other business services. Connect with our team today." image="https://ravemora.com/og/og-contact.jpg" />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <div className="label-eyebrow text-navy/60">Contact</div>
          <h1 className="serif-display text-5xl md:text-6xl leading-[0.95] mt-6">Let's talk.</h1>
          <p className="mt-6 text-lg text-navy/70 max-w-md">Whether you are hiring, being hired, or moving payroll to us — we respond to every enquiry within 24 hours.</p>
          <div className="hairline my-10" />
          <ul className="space-y-6 text-navy/80">
            <li><div className="label-eyebrow text-gold">Bengaluru HQ</div><div className="mt-1">Guru Krupa Arcade, Basavanapura Main Road, KR Puram, Bangalore</div></li>
            <li><div className="label-eyebrow text-gold">Email</div><div className="mt-1">info@ravemora.com</div></li>
            <li><div className="label-eyebrow text-gold">Phone</div><div className="mt-1">+91 74835 00550</div></li>
          </ul>
        </div>
        <form className="lg:col-span-7 bg-white border border-navy/10 p-10" onSubmit={submit} data-testid="contact-form">
          <div className="grid md:grid-cols-2 gap-5">
            <div><Label>Name*</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name"/></div>
            <div><Label>Email*</Label><Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email"/></div>
            <div><Label>Company</Label><Input value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} data-testid="contact-company"/></div>
            <div><Label>Phone</Label><Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="contact-phone"/></div>
            <div className="md:col-span-2"><Label>Subject</Label><Input value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} data-testid="contact-subject"/></div>
            <div className="md:col-span-2"><Label>Message*</Label><Textarea rows={6} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message"/></div>
          </div>
          <div className="mt-8"><MathCaptcha onValid={setCaptchaOk} testidPrefix="contact-captcha" /></div>
          <button className="btn-primary mt-6" disabled={submitting} data-testid="contact-submit">{submitting ? "Sending..." : "Send message"}</button>
        </form>
      </div>
    </div>
  );
}
